import React, {
  useContext,
} from 'react';

import ChatChannelContext from '../../../../context/ChatChannelContext';
import { attachmentPreviewPropTypes } from '../../../../utils/attachments';
import { StyledVideo } from './styles';

const defaultVideoType = 'video/mp4';

const VideoMessageAttachment = ({ assetLocalUrl, attachmentData }) => {
  const { setIsVideoReady } = useContext(ChatChannelContext);

  return (
    <StyledVideo
      controls
      onCanPlayThrough={() => setIsVideoReady(true)}
    >
      <source src={assetLocalUrl} type={attachmentData.mimeType} />
      <source src={assetLocalUrl} type={defaultVideoType} />
    </StyledVideo>
  );
};

VideoMessageAttachment.propTypes = attachmentPreviewPropTypes;

VideoMessageAttachment.defaultProps = {};

export default VideoMessageAttachment;
